import classNames from 'classnames'
import React from 'react'
import { SubscriptionType, subscriptionTypePositions, SubscriptionTypes } from '../Page'
import { TableGroupRowProps } from './TableGroup'

export interface TableGroupRowMobileProps extends TableGroupRowProps{
  subscriptionType?: SubscriptionType
}

const TableGroupRowMobile: React.FC<TableGroupRowMobileProps> = ({
  title,
  description,
  descriptionLink,
  checkedValues,
  subscriptionType,
  oddRow,
}) => {
  const subscriptionTypeHasFeature = () => {
    if (subscriptionType === undefined) return false

    if (subscriptionType === SubscriptionTypes.Robot) return true

    const checkedValuesIndex = subscriptionTypePositions.indexOf(subscriptionType)

    return checkedValues[checkedValuesIndex] === 'true'
  }

  const renderIcon = () => {
    if (subscriptionTypeHasFeature()) {
      return <i className='subscriptions-pricing__table-group-row-icon fal fa-circle-check'></i>
    } else {
      return <i className='subscriptions-pricing__table-group-row-icon far fa-dash'></i>
    }
  }

  return (
    <div
      className={classNames('subscriptions-pricing__table-group-row', {
        'subscriptions-pricing__table-group-row--odd': oddRow,
      })}
    >
      <div>
        {title && <p className='subscriptions-pricing__table-group-row-title'>{title}</p>}
        {descriptionLink ? (
          <a
            className='subscriptions-pricing__table-group-row-link'
            href={descriptionLink}
            target='_blank'
            rel='noreferrer'
          >
            <p className='subscriptions-pricing__table-group-row-description'>{description}</p>
            <i className='far fa-arrow-up-right-from-square'></i>
          </a>
        ) : (
          <p className='subscriptions-pricing__table-group-row-description'>{description}</p>
        )}
      </div>
      {renderIcon()}
    </div>
  )
}

export default TableGroupRowMobile
